<template>
  <div class="full-height d-flex flex-column">
    <div>
      <v-app-bar
        dense
        elevation="3"
        class="d-flex justify-center"
        color="#78b578"
        dark
        v-if="map_title"
      >
        <v-toolbar-title>{{ map_title }}</v-toolbar-title>
      </v-app-bar>
    </div>
    <div style="flex: 1">
      <Map
        readonly
        ref="map"
        :titleLayerControl="layer_title"
        :center="map_position"
        :minZoom="minZoom"
        :legends="legends"
      />
    </div>
  </div>
</template>

<script>
import { callRef } from '@/src/utils'
import { API_MAPSHARE } from '@api'
import Map from '@views/map/map-share.vue'

export default {
  components: { Map },
  data: () => ({
    map_title: null,
    layer_title: null,
    minZoom: 4,
    legends: [],
    map_position: {
      center: [105.19084739818732, 15.827971829957548],
      zoom: 5.297175623863693,
      maxZoom: 22,
    },
  }),
  mounted() {
    this.getLayer()
  },
  methods: {
    async getLayer() {
      const key = this.$route.query.key
      if (key) {
        let response = await API_MAPSHARE.getMapData({ key })
        const map = response?.data?.data?.meta?.map
        this.map_title = response?.data?.data?.title_map_style?.map_title
        this.layer_title = response?.data?.data?.layer_title
        this.legends = response?.data?.data?.legends || []

        const center_lat = response?.data?.data?.center_lat
        const center_lng = response?.data?.data?.center_lng
        const zoom_level = response?.data?.data?.zoom_level
        this.minZoom = response?.data?.data?.min_zoom || 4
        if (center_lat && center_lng) {
          this.map_position = {
            center: [center_lng, center_lat],
            zoom: zoom_level ? zoom_level : 5,
          }
        }
        if (map) {
          callRef(
            () =>
              this.$refs.map.setDataSave(
                map,
                response?.data?.data?.title_map_style
              ),
            () => this.$refs.map
          )
        }
      }
    },
  },
}
</script>

<style scoped></style>
